import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-rs005-card-XIII',
    templateUrl: './rs005-card-XIII.component.html'
})

export class Rs005CardXIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listOptionsFxVermelho?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsFxMarrom?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Faixas Genéticas', false);
        if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                faixa_vermelha: [null, [Validators.required]],
                faixa_marrom: [null, [Validators.required]],
            });
        }
        else {
            this.formulario = this.formBuilder.group({

            });
        }
    }

    public async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await this.getListOption();
    }


    private async getListOption(): Promise<void> {

        await this.formularioService.getListDropDownList('rs005', 'faixa_vermelha').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsFxVermelho = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });

        await this.formularioService.getListDropDownList('rs005', 'faixa_marrom').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsFxMarrom = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });

    }

}
